import "./AnalysisHeader.scss";

import { Flex, Header, Text } from "@fluentui/react-northstar";
import { getScheduleTextWithIcon, getStateTextWithIcon } from "@teams/cards";
import { ScheduleDTO, SurveyDTO, UserDTO } from "@teams/types/api";
import moment from "moment";
import React from "react";

import { SeriesMenu } from "./Menus/SeriesMenu/SeriesMenu";
import { TeamChannel } from "./TeamChannel";

type AnalysisHeaderParams = {
  series: ScheduleDTO;
  survey?: SurveyDTO;
  user: UserDTO;
  onChanged: () => void;
};
export const AnalysisHeader: React.FC<AnalysisHeaderParams> = ({
  series,
  survey,
  onChanged,
  user,
}) => {
  let header = series.name;
  if (survey) {
    header = `${series.name} - ${moment(survey.closeAt).format("MMM D, YYYY")}`;
  }

  const channel = {
    applicationType: series.applicationType,
    channelId: series.recipients[0].id,
    channelName: series.recipients[0].name,
  };

  return (
    <>
      <Flex>
        <Flex.Item grow={1}>
          <div>
            <TeamChannel channel={channel} />
          </div>
        </Flex.Item>
        <Flex.Item push>
          <SeriesMenu user={user} schedule={series} onChanged={onChanged} showEditOption={false} />
        </Flex.Item>
      </Flex>
      <Header className="analysis-header" content={header} as="h2" />
      <div>
        <Text className="analysis-header__label" content="Sender:" weight="bold" />
        <Text content={series.owners.map(o => o.name).join(", ")} />
      </div>
      <div>
        <Text className="analysis-header__label" content="Status:" weight="bold" />
        <Text content={getStateTextWithIcon(series.state)} />
      </div>
      <div>
        <Text className="analysis-header__label" content="Settings:" weight="bold" />
        <Text
          content={`${getScheduleTextWithIcon(series.frequency, moment(series.next).format("LT"))}`}
        />
      </div>
      <div>
        <Text className="analysis-header__label" content="Questions:" weight="bold" />
        <Text
          content={`💬 ${
            survey?.questions.length ||
            series.lastSurvey?.questions.length ||
            series.template?.questions.length
          }`}
        />
      </div>
    </>
  );
};
